'use client'

import { LenisFadeIn } from '@/components/animations/LenisReveal'
import LogoStrip, { type LogoStripItem } from '@/components/marketing/LogoStrip'

interface CompanyLogosProps {
  title?: string
  logos?: LogoStripItem[]
}

// Exported for the homepage TrustSection, which reuses the same client set.
export const DEFAULT_LOGOS: LogoStripItem[] = [
  {
    name: 'Egis',
    light: '/egis-vector-logo-light.svg',
    dark: '/egis-vector-logo-dark.svg',
    displayH: 40,
  },
  {
    name: 'Got Volunteers',
    light: '/got-volunteers-min-light.png',
    dark: '/got-volunteers-min-dark.png',
    displayH: 40,
  },
  {
    name: 'Parsons Corporation',
    light: '/parsons-corporation-vector-logo-2022-light.svg',
    dark: '/parsons-corporation-vector-logo-2022-dark.svg',
    displayH: 40,
  },
  {
    name: 'Enterprise Logistics',
    light: '/road-runner-logistics-light.svg',
    dark: '/road-runner-logistics-dark.svg',
    displayH: 40,
  },
  {
    name: 'Salesforce',
    light: '/Salesforce-light.svg',
    dark: '/Salesforce-dark.svg',
    displayH: 40,
  },
  {
    name: 'Vlocity',
    light: '/vlocity-logo-light.svg',
    dark: '/vlocity-logo-dark.svg',
    displayH: 40,
  },
]

const CompanyLogos = ({
  title = 'Trusted by teams shipping AI that actually works',
  logos = DEFAULT_LOGOS,
}: CompanyLogosProps) => {
  return (
    <section className='py-20 overflow-hidden'>
      <div className='container mx-auto px-4'>
        <LenisFadeIn revealOnScroll>
          <h2 className='text-center mb-6'>{title}</h2>
          <p className='text-center text-muted-foreground max-w-3xl mx-auto mb-8 text-lg leading-relaxed'>
            Teams we&apos;ve built with and worked alongside.
          </p>
        </LenisFadeIn>

        <LenisFadeIn delay={200} revealOnScroll>
          <LogoStrip items={logos} layout='marquee' className='pt-16' />
        </LenisFadeIn>
      </div>
    </section>
  )
}

export default CompanyLogos
